import React from 'react';
import makeStyles from '@mui/styles/makeStyles';
import { maybe } from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/util';
import ActivityFooter from './ActivityFooter';
import ActivityHeader from './ActivityHeader';
import Instructions from './Instructions';
import SpelledWord from './SpelledWord';
import { useSoundOutWords } from 'state/hooks/use-sound-out-words';

const ActivityPage: React.FC = () => {
  const classes = useStyles();
  const [{ activityStarted }] = useSoundOutWords();

  const MaybeSpelledWord = maybe(SpelledWord);
  const MaybeInstructions = maybe(Instructions);

  return (
    <>
      <ActivityHeader />
      <div className={classes.mainContent}>
        <MaybeSpelledWord shouldRender={activityStarted} />
        <MaybeInstructions shouldRender={!activityStarted} />
      </div>
      <ActivityFooter />
    </>
  );
};

export default ActivityPage;

const useStyles = makeStyles({
  mainContent: {
    display: 'flex',
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    margin: '0 2rem',
  },
});
